var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInformationOutline({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.3335 6.28385H8.66683V4.95052H7.3335V6.28385ZM8.00016 13.6172C5.06016 13.6172 2.66683 11.2239 2.66683 8.28385C2.66683 5.34385 5.06016 2.95052 8.00016 2.95052C10.9402 2.95052 13.3335 5.34385 13.3335 8.28385C13.3335 11.2239 10.9402 13.6172 8.00016 13.6172ZM8.00016 1.61719C7.12468 1.61719 6.25778 1.78963 5.44894 2.12466C4.6401 2.45969 3.90517 2.95075 3.28612 3.56981C2.03588 4.82005 1.3335 6.51574 1.3335 8.28385C1.3335 10.052 2.03588 11.7477 3.28612 12.9979C3.90517 13.617 4.6401 14.108 5.44894 14.4431C6.25778 14.7781 7.12468 14.9505 8.00016 14.9505C9.76827 14.9505 11.464 14.2481 12.7142 12.9979C13.9645 11.7477 14.6668 10.052 14.6668 8.28385C14.6668 7.40838 14.4944 6.54147 14.1594 5.73263C13.8243 4.92379 13.3333 4.18887 12.7142 3.56981C12.0952 2.95075 11.3602 2.45969 10.5514 2.12466C9.74255 1.78963 8.87564 1.61719 8.00016 1.61719ZM7.3335 11.6172H8.66683V7.61719H7.3335V11.6172Z",
    fill: "#767D93"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInformationOutline);
export default __webpack_public_path__ + "static/media/information-outline.888a6cea8a2cf5d97d0b1f79ee24fec9.svg";
export { ForwardRef as ReactComponent };